/**
 * Asynchronously loads MonthlyMustWinsView when the Must Wins toggle is enabled.
 */

import { lazyLoad } from 'utils/loadable';

export const MonthlyMustWinsView = lazyLoad(
  () => import('./components/MonthlyMustWinsView'),
  module => module.MonthlyMustWinsView
);
